'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PageBase2 = require('./PageBase');

var _PageBase3 = _interopRequireDefault(_PageBase2);

var _Header = require('../components/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Footer = require('../components/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageLayout = function (_PageBase) {
  _inherits(PageLayout, _PageBase);

  function PageLayout() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, PageLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PageLayout)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.containerClass = 'salt-pagelayout', _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PageLayout, [{
    key: 'renderHeader',
    value: function renderHeader() {
      return _react2.default.createElement(
        'div',
        { className: 'pagelayout-header' },
        _react2.default.createElement(_Header2.default, { dataList: this.header, navList: this.headerNav })
      );
    }
  }, {
    key: 'renderMain',
    value: function renderMain() {
      return _react2.default.createElement(
        'h2',
        null,
        '请自行覆盖renderMain等方法'
      );
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      return _react2.default.createElement(
        'div',
        { className: 'pagelayout-footer' },
        _react2.default.createElement(_Footer2.default, null)
      );
    }
  }]);

  return PageLayout;
}(_PageBase3.default);

exports.default = PageLayout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_rs-page@0.0.3@rs-page/lib/core/PageLayout.js
// module id = 1913
// module chunks = 0